import { useEffect, useState } from "react";

const StudentProfile = ({ data }) => {
  const [key, setKey] = useState("");


  useEffect(() => {
     console.log('profile data',data);
    // console.log(key);
  }, [key]);

 

  return (
    <>
      {data && data._id && (
        <div
          className="spWrapper  "
          style={{
            height: "400px",
            boxShadow: "0px 10px 10px 0px rgba(0, 31, 51, 0.10)",
          }}
        >
          <div className="spContent">
            <div className="spContent01">
              {/* {data.fullName} */}
              {data.fullName
    ?.split(" ")
    .map(word => word.charAt(0).toUpperCase())
    .join("")}
            </div>

            <div className="spContent02">
              {data.fullName}
            </div>
            <div className="spContent03">+91{data.phone}</div>
          </div>
          
        </div>
      )}
    </>
  );
};
export default StudentProfile;
